import { useLocation, useParams } from "react-router-dom";

const AffiliateReport = () => {
    const { id } = useParams();
    const location = useLocation();
    const isEditMode = Boolean(id);

    return (
        <>AffiliateDashboard</>
    )
}
export default AffiliateReport